import type { PlacesLocationDetails } from './placesLocation.types';

export type PlaceSortField = 'rating' | 'distance' | 'popularity';
export type PlaceSortOrder = 'asc' | 'desc';
export type PlacesFormSort = `${PlaceSortField}:${PlaceSortOrder}`;

export type PlacesSearchFormData = {
  location: string;
  location_details?: PlacesLocationDetails;
  placeType: string;
  distanceFromCenter: string;
  sortBy: PlacesFormSort;
};

export const PLACES_SEARCH_INITIAL_VALUES: PlacesSearchFormData = {
  location: '',
  location_details: undefined,
  placeType: '',
  distanceFromCenter: '',
  sortBy: 'rating:asc',
};

export const PLACES_FORM_SORT_OPTIONS: { value: PlacesFormSort; label: string }[] = [
  { value: 'rating:asc', label: 'Best Rating' },
  { value: 'distance:asc', label: 'Distance' },
  { value: 'popularity:asc', label: 'Popularity' },
];
